























import UUIFComponents from '@/shared/uuifComponent';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import { SwModal, SwModalBody, SwModalFooter } from '@sonicwall/unified-ui-framework/src/shared/sw-modal';
import { SwButton } from '@sonicwall/unified-ui-framework/src/shared/sw-button';
import { required, email } from 'vuelidate/lib/validators';
import { InfoState } from '@/core';

@Component({
  components: {
    ...UUIFComponents,
    SwModal,
    SwModalBody,
    SwModalFooter,
    SwButton,
  },
  validations:{
    userEmail: { required, email },
  },
})

export default class EmailQuoteModal extends SwExtendedVue{
  @Prop()
  isEmailModal: boolean;
  @Prop()
  email: any;
  @Prop()
  quoteId: any;

  selectOptions: any = [
    {
      id: '0',
      label: this.$t('quote.selEmailOpt')
      .toString(),
      value: '0',
    },
  ];
  selectValue: any = '0';
  errorMsg:boolean = true;
  userEmail: string = '';
  isSubmit: boolean = true;

  mounted() {
    this.selectOptions[1] = {
      id: '1',
      label: this.$props.email,
      value: '1',
    };
    this.selectOptions[2] = {
      id: '2',
      label: this.$t('quote.diffEmailAddr')
      .toString(),
      value: '2',
    };
  }
  sendEmail() {
    let submitData = false;
    if (this.selectValue === '1') {
      this.userEmail = this.selectOptions[1].label;
      submitData = true;
    } else if (this.selectValue === '2' && !this.$v.userEmail?.$invalid) {
      submitData = true;
    } else {
      submitData = false;
    }
    if (submitData) {
      const emailData = { equoteId : this.$props.quoteId, emailAddress : this.userEmail };
      this.$store
        .dispatch('SnbQuotesStoreModule/emailQuote', emailData)
        .then((res:any) => {
          this.$store.commit('stopLoading');
          if (res.operationStatus === 'OK') {
            const message: InfoState = { infoType: 'success', infoMsg: res.msgDesc };
            this.$store.commit('displayMessage', message);
            this.$emit('closeModal');
          } else {
            const message: InfoState = { infoType: 'high', infoMsg: res.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        });
    }
  }
  closeDialog() {
    this.$emit('closeModal');
  }
  selectedEmailOption() {
    if (this.selectValue === '0') {
      this.isSubmit = false;
    } else if (this.selectValue === '1') {
      this.isSubmit = true;
    } else {
      this.isSubmit = false;
    }
    this.userEmail = '';
  }
}
